import { gql } from "@apollo/client"
import { Company, QueryCompanyArgs } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"

const GET_STRIPE_ACH_PAYMENT_METHOD = gql`
  query CompanyStripeAchPaymentMethodFragment($companyId: ID!) {
    company(companyId: $companyId) {
      id
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          state
        }
      }
    }
  }
`

type QueryPayload = { company?: Pick<Company, "paymentMethod"> }
type QueryArgs = QueryCompanyArgs

export const useStripeAchPaymentMethod = ({ companyId }: QueryArgs) =>
  useQuery<QueryPayload, QueryArgs>(GET_STRIPE_ACH_PAYMENT_METHOD, { variables: { companyId } })
